import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core/styles';
import Entry from './Entry';

export function EventEntry(props) {
  const {
    event, theme, onDateSelected, focused,
  } = props;
  const eventData = {
    class: event.code.class_field,
    type: event.code.type,
    description: event.code.descript,
    location: event.loc ? event.loc.name : null,
    details: event.details,
  };

  const eventDetails = Object.keys(eventData).map((key) => {
    const value = eventData[key];
    if (!value) return null;
    return { key, value };
  }).filter(i => i !== null);

  const rowColor = theme.logbook.palette.eventEntry;

  return (
    <Entry
      focused={focused}
      onDateSelected={onDateSelected}
      style={{ backgroundColor: rowColor }}
      date={event.date}
      details={eventDetails}
      type="event"
    />
  );
}

EventEntry.propTypes = {
  event: PropTypes.shape().isRequired,
  theme: PropTypes.shape().isRequired,
  onDateSelected: PropTypes.func,
  focused: PropTypes.bool,
};
EventEntry.defaultProps = {
  onDateSelected: () => {},
  focused: false,
};

export default withTheme()(EventEntry);



// WEBPACK FOOTER //
// ./src/layout/logbook/EventEntry.jsx